export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

export const formatDateToMonthDDYYYYTimeFormat = (dateString) => {
  if (!dateString) return "-";

  const normalizedDate = dateString.includes(".")
    ? dateString.replace(/\.\d+/, (match) => match.substring(0, 4)) +
      (dateString.endsWith("Z") ? "" : "Z")
    : dateString + (dateString.endsWith("Z") ? "" : "Z");

  const date = new Date(normalizedDate);

  if (isNaN(date.getTime())) return "-";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Asia/Kolkata",
  });
};

export const formatDateDDMMYYTime = (dateString) => {
  if (!dateString) return "";

  const normalizedDate = dateString.includes(".")
    ? dateString.replace(/\.\d+/, "") // Remove milliseconds if present
    : dateString;

  const date = new Date(normalizedDate);

  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
};

export const convertToIST = (utcString) => {
  if (!utcString) return "";
  const isoSafeDate =
    utcString.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(utcString)
      ? utcString
      : `${utcString}Z`;
  const date = new Date(isoSafeDate);

  if (isNaN(date.getTime())) return "";

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const parts = formatter.formatToParts(date);
  const getPart = (type) => parts.find((part) => part.type === type)?.value;

  const day = getPart("day");
  const month = getPart("month")?.toLowerCase();
  const year = getPart("year");
  const hour = getPart("hour");
  const minute = getPart("minute");
  const period = getPart("dayPeriod")?.toLowerCase();

  if (!day || !month || !year || !hour || !minute || !period) {
    return "";
  }

  const dayWithoutLeadingZero = String(Number(day));

  return `${dayWithoutLeadingZero} ${month} ${year}, ${hour}:${minute} ${period}`;
};

export const formatDateToISTFull = (dateString) => {
  if (!dateString) return "";

  const normalizedDate = dateString.includes(".")
    ? dateString.replace(/\.\d+/, (match) => match.substring(0, 4))
    : dateString;

  const isoSafeDate = normalizedDate.endsWith("Z")
    ? normalizedDate
    : `${normalizedDate}Z`;

  const date = new Date(isoSafeDate);

  if (isNaN(date.getTime())) return "";

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const parts = formatter.formatToParts(date);
  const getPart = (type) => parts.find((part) => part.type === type)?.value;

  const day = getPart("day");
  const month = getPart("month")?.toLowerCase();
  const year = getPart("year");
  const hour = getPart("hour");
  const minute = getPart("minute");
  const second = getPart("second");
  const period = getPart("dayPeriod")?.toLowerCase();

  if (!day || !month || !year || !hour || !minute || !second || !period) {
    return "";
  }

  return `${day} ${month} ${year}, ${hour}:${minute}:${second} ${period}`;
};
